<ng-container>
  <ng-container *ngIf="singleFilter">
    <elio-single-filter [filter]="singleFilter" [hasTranslation]="hasTranslation" />
  </ng-container>
  <ng-container *ngIf="orFilter">
    <elio-filter-accordion *elioHasPermissionIsSuperAdmin="orFilter.superAdminOnly" [filter]="orFilter" />
  </ng-container>
  <ng-container *ngIf="andFilter">
    <elio-filters-list *elioHasPermissionIsSuperAdmin="andFilter.superAdminOnly" [filter]="andFilter" />
  </ng-container>
</ng-container>
